import React from "react";

const ExpenseIcon = () => {
  return (
    <div>
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.835 5.559c-.889 0-1.734-.1-2.5-.28-.8-.187-1.667.39-1.667 1.228v9.174c0 .674 0 1.01.162 1.358.092.198.302.468.47.604.296.239.542.296 1.035.412.766.179 1.611.278 2.5.278 1.597 0 3.056-.321 4.166-.851 1.11-.53 2.57-.852 4.167-.852.888 0 1.734.1 2.5.279.8.187 1.667-.389 1.667-1.228V6.507c0-.673 0-1.01-.162-1.358a2.01 2.01 0 00-.47-.603C16.667 3.699 15 4.536 15 4.536"
          stroke="#044E97"
          strokeWidth={1.2}
          strokeLinecap="round"
        />
        <path
          d="M12.085 11.25a2.083 2.083 0 11-4.167 0 2.083 2.083 0 014.167 0z"
          stroke="#044E97"
          strokeWidth={1.2}
        />
        <path
          d="M4.586 12.084v.007M15.418 10.41v.008M7.918 3.75c.41-.421 1.5-2.083 2.083-2.083m2.084 2.083c-.41-.421-1.5-2.083-2.084-2.083m0 0v5"
          stroke="#044E97"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export { ExpenseIcon };
